import { nortadaLogger } from '../../../../../../common/logger';

import { EventItem, OPERATION_DETAILS_EVENT_TYPE } from './interfaces';

export const mapLogValue = (event: EventItem) => {
  switch (event.type) {
    case OPERATION_DETAILS_EVENT_TYPE.SPECIAL_EVENT: {
      return event.text;
    }
    case OPERATION_DETAILS_EVENT_TYPE.USER_INPUT: {
      return event.input;
    }
    case OPERATION_DETAILS_EVENT_TYPE.USSD_APP_RESPONSE: {
      return event.response;
    }
    default: {
      return nortadaLogger.error(`Wrong type declared in ${JSON.stringify(event)}`);
    }
  }
};
